// その他精算項目 section — fee inputs, total, required receipts.
import { Receipt as ReceiptIcon, Trash, FileArrowUp } from '@phosphor-icons/react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { API } from './travelModel';

export const OtherFeesSection = ({
  formData, totalAmount, otherReceiptsRequired, otherReceiptsMissing, uploading,
  onChange, onUpload, onRemoveReceipt,
}) => (
  <div className="rounded-lg border border-zinc-200 bg-zinc-50/40 p-5 sm:p-6">
    <div className="flex items-center gap-2 mb-4">
      <div className="h-7 w-1 rounded-full bg-teal-700" />
      <h3 className="text-sm font-bold uppercase tracking-wider text-zinc-700">その他精算項目</h3>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <div>
        <Label htmlFor="accommodation_fee" className="font-bold">宿泊料（円）</Label>
        <Input id="accommodation_fee" data-testid="travel-fee-accommodation" type="number" step="1" value={formData.accommodation_fee} onChange={(e) => onChange('accommodation_fee', e.target.value)} className="border-zinc-300 focus:ring-2 focus:ring-blue-500" />
      </div>
      <div>
        <Label htmlFor="daily_allowance" className="font-bold">日当（円）</Label>
        <Input id="daily_allowance" data-testid="travel-fee-daily-allowance" type="number" step="1" value={formData.daily_allowance} onChange={(e) => onChange('daily_allowance', e.target.value)} className="border-zinc-300 focus:ring-2 focus:ring-blue-500" />
      </div>
      <div>
        <Label htmlFor="meal_fee" className="font-bold">食事代（円）</Label>
        <Input id="meal_fee" type="number" step="1" value={formData.meal_fee} onChange={(e) => onChange('meal_fee', e.target.value)} className="border-zinc-300 focus:ring-2 focus:ring-blue-500" />
      </div>
      <div>
        <Label htmlFor="other_fees" className="font-bold">その他（円）</Label>
        <Input id="other_fees" data-testid="travel-fee-other" type="number" step="1" value={formData.other_fees} onChange={(e) => onChange('other_fees', e.target.value)} className="border-zinc-300 focus:ring-2 focus:ring-blue-500" />
      </div>
    </div>
    <div className="mt-5 rounded-xl bg-gradient-to-br from-[#E5EDFF] to-[#F4F7FF] border border-[#B3CBFF] px-5 py-4 flex items-center justify-between">
      <Label className="text-sm font-semibold text-teal-700 uppercase tracking-wider">合計金額</Label>
      <div className="text-3xl font-bold text-teal-700 tabular-nums">¥{totalAmount.toLocaleString()}</div>
    </div>

    {/* Receipts for その他精算項目 — required when any of those fees > 0 */}
    {otherReceiptsRequired && (
      <div className={`mt-4 rounded-md border px-4 py-3 ${otherReceiptsMissing ? 'border-amber-300 bg-amber-50/60' : 'border-emerald-300 bg-emerald-50/40'}`}>
        <div className="flex items-start gap-3 mb-2">
          <ReceiptIcon size={18} weight="duotone" className={`shrink-0 mt-0.5 ${otherReceiptsMissing ? 'text-amber-700' : 'text-emerald-700'}`} />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-zinc-900">
              その他精算項目の領収書 <span className={otherReceiptsMissing ? 'text-amber-700' : 'text-emerald-700'}>*必須</span>
            </p>
            <p className="text-xs text-zinc-600 mt-0.5">
              宿泊料・日当・食事代・その他に金額を入力した場合、領収書の添付が必須です。<br />
              PDF（最大 8MB / 1ファイル・複数選択可）
            </p>
          </div>
        </div>

        {(formData.other_receipts || []).length > 0 && (
          <ul className="space-y-2 mb-3" data-testid="other-receipt-list">
            {formData.other_receipts.map((r) => (
              <li key={r.id} className="flex items-center gap-3 bg-white border border-zinc-200 rounded px-3 py-2">
                {r.content_type?.startsWith('image/') ? (
                  <img src={`${API}/receipts/${r.id}`} alt={r.filename} className="w-10 h-10 object-cover rounded border border-zinc-200" />
                ) : (
                  <div className="w-10 h-10 flex items-center justify-center bg-zinc-100 rounded border border-zinc-200">
                    <ReceiptIcon size={18} className="text-zinc-500" />
                  </div>
                )}
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-medium text-zinc-900 truncate">{r.filename}</p>
                  <p className="text-xs text-zinc-500">{Math.round((r.size || 0) / 1024)} KB</p>
                </div>
                <button
                  type="button"
                  data-testid={`remove-other-receipt-${r.id}`}
                  onClick={() => onRemoveReceipt(r.id)}
                  className="p-1.5 text-zinc-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                  title="削除"
                >
                  <Trash size={16} />
                </button>
              </li>
            ))}
          </ul>
        )}

        <label className="inline-flex items-center gap-2 text-sm font-medium text-zinc-700 hover:text-zinc-900 bg-white border border-zinc-300 rounded px-3 py-2 cursor-pointer transition-colors">
          <FileArrowUp size={16} />
          {uploading ? 'アップロード中…' : '領収書を追加'}
          <input
            type="file"
            accept="application/pdf"
            multiple
            onChange={onUpload}
            disabled={uploading}
            data-testid="input-other-receipt-file"
            className="hidden"
          />
        </label>
      </div>
    )}
  </div>
);
